/* SS - Product Reviews: moves the review slider next to the product form / title / description (as the original did). */
(() => {
  if (customElements.get('ss-product-reviews')) return;
  customElements.define(
    'ss-product-reviews',
    class extends HTMLElement {
      connectedCallback() {
        const t = this.querySelector('template');
        const el = t && t.content.firstElementChild;
        if (!el) return;
        const target = document.querySelector('#ss-reviews') || document.querySelector(this.dataset.target);
        if (!target) return;
        target.insertAdjacentElement(this.dataset.where, el);
        this.moved = el;
      }
      disconnectedCallback() {
        if (this.moved) this.moved.remove();
        this.moved = null;
      }
    }
  );
})();
